import { render } from "./rwc_program_consent_checkbox.vue?vue&type=template&id=da3246e8"
import script from "./rwc_program_consent_checkbox.vue?vue&type=script&lang=js"
export * from "./rwc_program_consent_checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__